<div id="dsw" class="layout-section">
  <app-header></app-header>
  <div class="mb-auto">
    <router-outlet></router-outlet>
  </div>
  <footer class="footer mt-auto">
    <div class="container">
      <div class="row flmid">
        <div class="col-12 col-md-12" *ngIf="widgetContacUsLink" >
          <p class="copyright clearfix m-0 text-center">
            <span translate>lblProbleminBooking </span>
            <a [href]='widgetContacUsLink'  class="clrblue" style="text-decoration: underline;" rel="noopener" target="_blank"><span translate>lblProbleminBookingContactUs</span></a>
            </p>
        </div>
        <div class="col-12 col-md-6">
          <p class="copyright clearfix m-0 text-center text-md-left">
            &copy;&nbsp;{{currentYear}}&nbsp;<span translate>lblCopyRight</span><a href="https://www.autofacets.com/" class="clrblue" rel="noopener" target="_blank"> AutoFacets</a>
            <span class="d-none d-sm-inline-block">, <span translate>lblAllRightReserved</span></span>
            <!-- version : 1.0 -->
          </p>
        </div>
        <div class="col-12 col-md-6   d-flex powered-text justify-content-center justify-content-md-end">
          <div class="d-flex align-items-center  ml-md-auto">
            <span translate>lblPoweredBy</span> <img class="brand" src="./../assets/images/afx/header-logo.svg" width="110" alt="Logo" />
          </div>

        </div>
      </div>
    </div>
  </footer>
</div>
<ngx-spinner size="medium" bdColor="rgba(0,0,0,0.3)" color="#414042" type="ball-clip-rotate" [zIndex]="1111113">
</ngx-spinner>
